/** Контент лендинга `/use-cases/meeting-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const MEETING_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ПЛАНЁРКИ, СОВЕТЫ, ПАНЕЛЬНЫЕ ДИСКУССИИ',
  heroLead:
    'Бесплатный онлайн-таймер для совещаний: видно, чей сейчас черёд говорить, без неловких взглядов на часы. Небольшие встречи ведите бесплатно — всё работает в браузере.',
  heroNote: 'Без карты и регистрации. Работает в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer помогает держать регламент, когда у каждого участника свой слот, а встреча не должна затягиваться.',
    items: [
      {
        title: 'Планёрки и стендапы',
        text: 'Короткий тайм-бокс на каждого: видно, чей черёд говорить, и никто не выбивается из времени.',
      },
      {
        title: 'Советы и комитеты',
        text: 'Регламент по пунктам повестки: отдельный таймер на доклад, активный слот виден всем.',
      },
      {
        title: 'Дебаты и панельные дискуссии',
        text: 'Равное время выступающим, а сигнал «завершайте» появляется прямо на экране.',
      },
    ],
  },

  share: {
    title: 'Просто запустить и легко поделиться',
    paragraphs: [
      'preztimer — таймер с удалённым управлением: запуск, пауза и сброс с любого устройства в браузере. Экран таймера и панель управления открываются по ссылке.',
      'Поделитесь экраном таймера с участниками, а панель управления оставьте у ведущего. Установка и регистрация не нужны: можно начать с гостевой комнаты.',
    ],
  },

  cloud: {
    title: 'Работает целиком в браузере',
    lead:
      'Участникам не нужно ничего скачивать. Открыли ссылку — и сразу видят отсчёт на любом устройстве.',
    bullets: [
      'крупные цифры таймера, читаются издалека;',
      'без загрузок и установки — только ссылка;',
      'ноутбук, планшет или телефон, любой современный браузер.',
    ],
  },

  communication: {
    title: 'Держите совещание в графике',
    lead:
      'Соберите повестку из таймеров: видно, чей слот идёт сейчас и сколько осталось. Без рекламы и лишних отвлечений.',
    bullets: [
      'отдельный таймер на доклад или выступающего;',
      'плановое время старта для пунктов повестки;',
      'короткие сообщения и предупреждения на экране.',
    ],
  },

  modes: {
    title: 'Сообщения и цветовые зоны на экране',
    lead:
      'Отправьте участникам короткое сообщение в один клик, а цветовые зоны подскажут, что время на исходе.',
    bullets: [
      'обратный отсчёт, секундомер или часы (время суток);',
      'цветовые зоны при приближении к нулю;',
      'после нуля виден перерасход в формате +00:01.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Небольшие встречи ведите бесплатно. Профи добавляет команду, больше таймеров и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: доклад, питч и один экран',
    lead:
      'Одно выступление без смены сетки слотов — отдельная страница с акцентом на регламент и быстрый старт.',
    to: '/use-cases/presentations',
    linkLabel: 'Таймер для презентаций и докладов',
  },

  faqSectionTitle: 'Частые вопросы о таймере для совещаний',
  faqItems: [
    {
      question: 'Можно ли вести совещание бесплатно?',
      answer:
        'Да. Базовые функции тайминга доступны бесплатно, начать можно с гостевой комнаты — без карты и регистрации. Для команды и больших лимитов есть лицензия Профи.',
    },
    {
      question: 'Видно ли, чей сейчас черёд говорить?',
      answer:
        'Да. Создайте отдельный таймер на каждого участника или пункт повестки — активный слот виден на панели управления и на экране таймера.',
    },
    {
      question: 'Можно ли автоматически переключать таймеры между выступающими?',
      answer:
        'Нет. Автопереходов между таймерами нет: запуск, пауза и переход к следующему таймеру выполняются вручную. Ведущий может добавить или убавить время во время встречи. Для слотов можно задать плановое время старта.',
    },
    {
      question: 'Сколько человек могут подключиться к таймеру?',
      answer:
        'Число одновременных подключений: на Базовом — 3, на Профи — 5 по умолчанию (до 25). На Профи доступны приглашения участников в команду.',
    },
    {
      question: 'Нужна ли установка или регистрация?',
      answer:
        'Нет. preztimer работает в браузере на компьютере, планшете и телефоне. Для быстрой встречи создайте гостевую комнату без аккаунта.',
    },
    {
      question: 'Какие режимы таймера доступны?',
      answer:
        'Обратный отсчёт, секундомер и режим часов (текущее время суток). Для обратного отсчёта можно включить показ перерасхода после нуля.',
    },
  ],
};
